<!-- BillDetailModal.vue -->
<template>
  <div class="modal fade" id="billDetailModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Bill Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-6">
              <address>
                <strong>Bill Prepared for:</strong><br>
                <span v-if="editingDescription">
                  <input type="text" v-model="editDescriptionValue" class="form-control mb-2" />
                  <div class="d-flex">
                    <button @click="saveDescriptionEdit" class="btn btn-sm btn-success me-2"
                            :disabled="saveDescriptionLoading">
                      <span v-if="saveDescriptionLoading">Saving...</span>
                      <span v-else>Save</span>
                    </button>
                    <button @click="cancelDescriptionEdit" class="btn btn-sm btn-secondary"
                            :disabled="saveDescriptionLoading">Cancel</button>
                  </div>
                </span>
                <span v-else>
                  {{ billDetail.description }}
                  <button v-if="getRight('EDIT INVOICE')" @click="startDescriptionEdit"
                          class="btn btn-sm btn-danger ms-2">
                    EDIT
                  </button>
                </span><br><br>
                On {{ billDetail.dateCreated }}
              </address>
            </div>
          </div>

          <div class="col-12">
            <div class="py-2 mt-3">
              <h3 class="font-size-15 fw-bold">{{ billNo }}</h3>
            </div>
          </div>

          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-nowrap">
                <thead class="bg-light">
                <tr>
                  <th style="width: 70px;">No.</th>
                  <th>Customer</th>
                  <th>Description</th>
                  <th class="text-end">Amount</th>
                  <th class="text-end">Actions</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="(item, index) in billInfo" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <div class="bill-item">
                        <span v-if="editingItem && editingItem.id === item.id">
                          <input type="text" v-model="editingValue" class="form-control mb-2" />
                          <div class="d-flex">
                            <button @click="saveEdit(item)" class="btn btn-sm btn-success me-2">Save</button>
                            <button @click="cancelEdit()" class="btn btn-sm btn-secondary">Cancel</button>
                          </div>
                        </span>
                      <span v-else>
                          {{ maskPhoneNumber(item.customer) }}
                          <button v-if="getRight('EDIT INVOICE')" @click="startEdit(item, item.customer)"
                                  class="btn btn-sm btn-danger ms-2">
                            EDIT
                          </button>
                        </span>
                    </div>
                  </td>
                  <td>{{ item.feeDescription }}</td>
                  <td class="text-end">KES {{ item.billTotal }}</td>
                  <td class="text-end">
                    <button v-if="getRight('INITIATE WAIVER')"
                            @click="openWaiver(item, 'INVOICE WAIVER')"
                            class="btn btn-sm btn-success me-2">
                      Waiver
                    </button>
                    <button v-if="getRight('INITIATE PWD')"
                            @click="openWaiver(item, 'PWD WAIVER')"
                            class="btn btn-sm btn-info">
                      PWD
                    </button>
                  </td>
                </tr>
                </tbody>

                <tfoot class="bg-light">
                <tr>
                  <td></td>
                  <td class="border-0 text-end" colspan="2">
                    <strong>Total</strong>
                  </td>
                  <td class="border-0 text-end">
                    <h5 class="m-0 fw-bold">KES {{ billDetail.detailAmount }}</h5>
                  </td>
                  <td></td>
                </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="printBill" class="btn btn-primary">
            <i class="mdi mdi-printer me-2"></i> Print Bill
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRight, execute, biller } from "@/api";

export default {
  name: "BillDetailModal",
  props: {
    billDetail: {
      type: Object,
      default: () => ({})
    },
    billInfo: {
      type: Array,
      default: () => []
    },
    billNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editingDescription: false,
      editDescriptionValue: '',
      saveDescriptionLoading: false,
      editingItem: null,
      editingValue: '',
      alert: {
        success: false,
        failed: false
      },
      message: ''
    }
  },
  methods: {
    getRight,

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    startDescriptionEdit() {
      this.editingDescription = true;
      this.editDescriptionValue = this.billDetail.description;
    },

    cancelDescriptionEdit() {
      this.editingDescription = false;
      this.editDescriptionValue = '';
    },

    async saveDescriptionEdit() {
      try {
        this.saveDescriptionLoading = true;

        const data = new FormData();
        data.append("function", "updateBillDescription");
        data.append("billNo", this.billDetail.billNo);
        data.append("description", this.editDescriptionValue);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        const res = await execute(data, biller);
        this.saveDescriptionLoading = false;

        if (res.data.success) {
          this.$emit('description-updated', {
            billNo: this.billDetail.billNo,
            description: this.editDescriptionValue
          });
          this.cancelDescriptionEdit();
          this.alert.success = true;
          this.message = "Bill description updated successfully";
        } else {
          this.alert.failed = true;
          this.message = res.data.message;
        }
      } catch (e) {
        this.saveDescriptionLoading = false;
        this.alert.failed = true;
        this.message = e.message;
      }
    },

    startEdit(item, value) {
      this.editingItem = item;
      this.editingValue = value;
    },

    cancelEdit() {
      this.editingItem = null;
      this.editingValue = '';
    },

    async saveEdit(item) {
      try {
        const data = new FormData();
        data.append("function", "updateCustomer");
        data.append("id", item.id);
        data.append("billNo", item.billNo);
        data.append("customer", this.editingValue);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));

        const res = await execute(data, biller);

        if (res.data.success) {
          this.$emit('customer-updated', {
            id: item.id,
            customer: this.editingValue
          });
          this.cancelEdit();
          this.alert.success = true;
          this.message = "Customer information updated successfully";
        } else {
          this.alert.failed = true;
          this.message = res.data.message;
        }
      } catch (e) {
        this.alert.failed = true;
        this.message = e.message;
      }
    },

    openWaiver(item, type) {
      this.$emit('open-waiver', item, type);
    },

    printBill() {
      this.$emit('print-bill');
    }
  }
}
</script>